import { isPageAtTop, getScrollTop } from "../utility/utility.js";

export default class MainNavigation {
  constructor() {
    this.currentDropdown = null;
    this.lastScrollPosition = 0;
    this.animationInProgress = false;
    this.lineDeviderVisible = false; // Initial state of the line divider visibility
    this.toggles = document.querySelectorAll(".js-toggle-mega-nav");
    this.dropdowns = document.querySelectorAll(".main-nav__dropdown");
    this.logoText = document.querySelector("#logo-nabohjaelp-text");
    this.desktopMenu = document.querySelector(".js-desktop-header");
    this.lineDevider = document.querySelector(".line-devider");
    this.init();
  }

  init() {
    this.bindEvents();
    this.toggleLineDevider();
    window.addEventListener(
      "scroll",
      this.debounce(() => {
        this.toggleLineDevider();
      }, 10)
    );
    this.listenForServiceMenuEvents();
  }

  bindEvents() {
    document.addEventListener("click", (e) => {
      let dropdownToggle = e.target.closest(".js-toggle-mega-nav");
      if (dropdownToggle) {
        if (dropdownToggle === this.currentDropdownToggle) {
          this.close();
          return;
        }
        if (this.currentDropdownToggle && this.currentDropdownToggle !== dropdownToggle) {
          this.close();
        }
        this.toggle(dropdownToggle);
      } else if (this.currentDropdown && !this.currentDropdown.contains(e.target)) {
        this.close();
      }
    });

    this.toggles.forEach((toggle) => {
      toggle.addEventListener("keydown", (e) => {
        if (e.key === "Tab" && !e.shiftKey && this.currentDropdownToggle) {
          e.preventDefault();
          let items = this.currentDropdown.querySelectorAll("a,button");
          let firstItem = items[0];
          firstItem.focus();
        }
      });
    });

    this.dropdowns.forEach((dropdown) => {
      let items = dropdown.querySelectorAll("a,button");
      let firstItem = items[0];
      let lastItem = items[items.length - 1];

      if (firstItem != undefined) {
        firstItem.addEventListener("keydown", (e) => {
          if (e.key === "Tab" && e.shiftKey) {
            e.preventDefault();
            this.currentDropdownToggle.focus();
            this.close();
          }
        });
      }

      if (lastItem != undefined) {
        lastItem.addEventListener("keydown", (e) => {
          if (e.key === "Tab" && !e.shiftKey) {
            e.preventDefault();

            this.currentDropdownToggle.focus();
            this.close();
          }
        });
      }

      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && this.currentDropdownToggle) {
          e.preventDefault();
          this.close();
        }
      });
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.currentDropdown) {
        e.preventDefault();
        this.close();
      }
    });
  }

  listenForServiceMenuEvents() {
    document.addEventListener("serviceMenu:opened", () => {
      this.lineDeviderVisible = true;
      this.toggleLineDevider(true);
    });

    document.addEventListener("serviceMenu:closed", () => {
      this.lineDeviderVisible = false;
      this.toggleLineDevider(false);
    });
  }

  toggle(dropdownToggle) {
    this.currentDropdownToggle = dropdownToggle;
    this.currentDropdownToggle.setAttribute("aria-expanded", true);
    this.currentDropdown = document.querySelector(`#${dropdownToggle.getAttribute("aria-controls")}`);
    this.open();
  }

  open() {
    this.currentDropdown.classList.add("is-open");
    document.dispatchEvent(new CustomEvent("dimmer:open"));
    this.currentDropdown.querySelectorAll("a,button").forEach((link) => {
      link.tabIndex = 0;
    });
    this.logoText.classList.add("hidden");
  }

  close() {
    if (!this.currentDropdown) return;
    this.currentDropdown.classList.remove("is-open");
    document.dispatchEvent(new CustomEvent("dimmer:close"));
    this.currentDropdown.querySelectorAll("a,button").forEach((link) => {
      link.tabIndex = -1;
    });
    this.currentDropdownToggle.setAttribute("aria-expanded", false);
    this.currentDropdown = null;
    this.currentDropdownToggle = null;
    this.logoText.classList.remove("hidden");
    this.toggle;
  }

  toggleLineDevider(forceVisible = null) {
    if (!this.animationInProgress && this.lineDevider) {
      const currentScrollPosition = getScrollTop();
      let shouldBeVisible = forceVisible !== null ? forceVisible : currentScrollPosition < this.lastScrollPosition || isPageAtTop();
      if (this.lineDeviderVisible !== shouldBeVisible) {
        this.lineDeviderVisible = shouldBeVisible;
        this.lineDevider.classList.toggle("line-devider-visible", shouldBeVisible);
        this.lineDevider.classList.toggle("line-devider-hidden", !shouldBeVisible);
      }

      this.lastScrollPosition = currentScrollPosition;
      setTimeout(() => {
        this.animationInProgress = false;
      }, 200);
    }
  }
  debounce(func, wait, immediate) {
    let timeout;
    return function executedFunction() {
      const context = this,
        args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
}
